// extracted by mini-css-extract-plugin
export var container = "about-us-module--container--sOAG0";
export var container_animation = "about-us-module--container_animation--iyEO3";
export var container_animation_hide = "about-us-module--container_animation_hide--DYoaz";
export var container_animation_show = "about-us-module--container_animation_show--uG6Md";
export var content_swapper_container = "about-us-module--content_swapper_container--tk76A";
export var content_swapper_container_show = "about-us-module--content_swapper_container_show--V-TVf";
export var drop_down_hide = "about-us-module--drop_down_hide--Fn4mu";
export var drop_down_show = "about-us-module--drop_down_show--aNnbQ";